module.exports = __webpack_public_path__ + "img/uploaderror.ea3e1895.svg";